import { h } from 'vue'
import { RouterView } from 'vue-router'
export default [
  {
    path: '/:lang/survey', // 支持语言前缀
    component: { render: () => h(RouterView) },
    meta: {
      defaultName: 'Survey',
      name: 'survey',
    },
    children: [
      {
        path: '/:lang/survey/brand-globalization', // 相对路径
        name: 'surveyBrandGlobalization',
        meta: {
          defaultName: 'Brand Globalization Capability Self-Assessment Form',
          name: 'Brand Globalization Capability Self-Assessment Form',
          pageCode: 'ERA.UC.Survey',
          noHeader: true,
        },
        component: () => import('~/pages/survey/brand-globalization'),
      },
    ],
  },
]
